import { cn } from '../../lib/cn';
import styles from './NotchedPanel.module.css';

/** Dark panel with the comp's stepped silhouette. See the module CSS for how. */
export function NotchedPanel({ className, children, ...rest }) {
  return (
    <div className={cn(styles.panel, className)} {...rest}>
      <span className={styles.shape} aria-hidden="true" />
      {children}
    </div>
  );
}
